export var General;
(function (General) {
    /**
     * Load init.js
     */
    let AppData;
    (function (AppData) {
        AppData.path = 'general/appData';
    })(AppData = General.AppData || (General.AppData = {}));
    /**
     * Load countries list
     */
    let Countries;
    (function (Countries) {
        Countries.path = 'general/countries';
    })(Countries = General.Countries || (General.Countries = {}));
    /**
     * Notify
     */
    let Notify;
    (function (Notify) {
        Notify.path = 'notify';
    })(Notify = General.Notify || (General.Notify = {}));
})(General || (General = {}));
